import React from "react";

import { BreadCrumbLink } from "./Link.styles";

export interface BreadcrumbLinkProps {
  to: string;
  children: React.ReactNode;
  $isActive?: boolean;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const Link = React.forwardRef<HTMLAnchorElement, BreadcrumbLinkProps>(
  ({ to, children, ...props }, ref) => (
    <BreadCrumbLink to={to} ref={ref} {...props}>
      {children}
    </BreadCrumbLink>
  )
);

Link.displayName = "Link";
